'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { TableOfContentsItem } from '../../types';

import { styles } from './TableOfContents.styles';

interface TableOfContentsProps {
  items: TableOfContentsItem[];
  onItemClick?: (id: string) => void;
  className?: string;
}

export function TableOfContents({
  items,
  onItemClick,
  className
}: TableOfContentsProps) {
  const slots = styles();

  const t = useTranslations();

  return (
    <div className={slots.base({ className })}>
      <h2 className={slots.title()}>{t('tableOfContents')}</h2>
      <ul className={slots.list()}>
        {items.map((item) => (
          <li key={item.id}>
            <Link
              href={`#${item.id}`}
              className={slots.itemLink()}
              onClick={() => onItemClick?.(item.id)}
            >
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
